(function () {
    'use strict';

    // Devuelve una fecha en formato largo en español
    function formatFechaLarga(ymd) {
        if (!ymd) return '';
        const [Y, M, D] = ymd.split('-').map(n => parseInt(n, 10));
        if (!Y || !M || !D) return '';
        const dt = new Date(Y, M - 1, D);

        const parts = new Intl.DateTimeFormat('es-MX', {
        weekday: 'long', day: 'numeric', month: 'long'
        }).formatToParts(dt).reduce((acc, p) => (acc[p.type] = p.value, acc), {});

        const dia = (parts.weekday || '').replace(/^./, c => c.toUpperCase());
        const mes = (parts.month || '').toLowerCase();
        return `${dia} ${parts.day || ''} de ${mes}`;
    }

    // Decodifica entidades HTML (&quot;, &amp;, etc.) por si llegan en data-*
    function decodeEntities(str) {
        if (typeof str !== 'string') return str;
        const txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
    }

    // Normaliza y devuelve un array desde un data-* (ej. data-mx, data-us, data-uk)
    function getDataArray(el, key) {
        let v = el.dataset ? el.dataset[key] : null;
        if (Array.isArray(v)) return v;
        if (v && typeof v === 'object') return [v];
        if (typeof v === 'string') {
        try { return JSON.parse(v); } catch {}
        try { return JSON.parse(decodeEntities(v)); } catch {}
        }
        const raw = el.getAttribute('data-' + key) || '[]';
        try { return JSON.parse(raw); } catch {}
        try { return JSON.parse(decodeEntities(raw)); } catch {}
        return [];
    }

    //Añadimos una fecha a la lista por país
    function addItem(listEl, it, country) {
        const li = document.createElement('li');
        li.className = 'calendar-widget__sidebar-item';
        li.setAttribute('data-date', it.fecha);
        if (country) li.setAttribute('data-country', country);

        li.innerHTML =
            `<p class="date">${formatFechaLarga(it.fecha)}</p>` +
            `<p>${it.titulo || ''}</p>`;
        listEl.appendChild(li);
    }

    //Inicializa calendario
    function initCalendar(widgetEl) {
        const root = widgetEl.closest('.trading__calendar') || widgetEl.parentElement;
        if (!root) return;

        root.querySelectorAll('.calendar-widget__sidebar-item.is-active')
        .forEach(el => el.classList.remove('is-active'));

        // Elementos principales del calendario
        const months = root.querySelectorAll('.calendar-widget__month');
        const lbl    = root.querySelector('.calendar-widget__header-current');
        const prev   = root.querySelector('.btn--prev-calendar');
        const next   = root.querySelector('.btn--next-calendar');

        // Listas laterales por país
        const listMX = root.querySelector('#gbm-list-mx');
        const listUS = root.querySelector('#gbm-list-us');
        const listUK = root.querySelector('#gbm-list-uk');

        const blockMX = listMX ? listMX.closest('.calendar-widget__sidebar-block') : null;
        const blockUS = listUS ? listUS.closest('.calendar-widget__sidebar-block') : null;
        const blockUK = listUK ? listUK.closest('.calendar-widget__sidebar-block') : null;

        if (!lbl || !months.length) return;

        const year = parseInt(lbl.getAttribute('data-year'), 10);
        const now  = new Date();
        let idx    = (year === now.getFullYear()) ? now.getMonth() : 0; // 0..11

        const monthNames = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

        // Muestra el mes donde cae dateStr (YYYY-MM-DD) si es distinto al visible
        function ensureMonthVisibleForDate(dateStr) {
            if (!dateStr) return;
            const d = new Date(dateStr + 'T00:00:00'); // fuerza parse sin timezone raro
            if (Number.isNaN(d.getTime())) return;
            const m = d.getMonth(); // 0..11
            if (m !== idx) setMonth(m);
            }

            // Resalta el día del calendario por fecha (en el mes visible)
            function highlightCalendarDayByDate(dateStr) {
            if (!dateStr) return;
            const currentMonthEl = months[idx];
            if (!currentMonthEl) return;

            // Limpiar previos
            currentMonthEl.querySelectorAll('.calendar-widget__day.is-highlighted')
                .forEach(el => el.classList.remove('is-highlighted'));

            // Marcar el día
            const dayEl = currentMonthEl.querySelector(`.calendar-widget__day.is-holiday[data-date="${dateStr}"]`);
            if (dayEl) {
                dayEl.classList.add('is-highlighted');
            }
        }

        // Limpia todo highlight en el calendario (mes visible)
        function clearCalendarHighlights() {
            const currentMonthEl = months[idx];
            if (!currentMonthEl) return;
            currentMonthEl.querySelectorAll('.calendar-widget__day.is-highlighted')
            .forEach(el => el.classList.remove('is-highlighted'));
        }

        // Activa o desactiva las flechas prev/next en enero/diciembre
        function setNavState() {
            if (prev) {
                const atStart = (idx === 0);
                prev.disabled = atStart;
                prev.classList.toggle('is-disabled', atStart);
            }
            if (next) {
                const atEnd = (idx === 11);
                next.disabled = atEnd;
                next.classList.toggle('is-disabled', atEnd);
            }
        }
        //Llenamos los datos de las listas por país
        function fillSidebar(i) {
            if (listMX) listMX.innerHTML = '';
            if (listUS) listUS.innerHTML = '';
            if (listUK) listUK.innerHTML = '';

            if (blockMX) blockMX.classList.remove('is-hidden');
            if (blockUS) blockUS.classList.remove('is-hidden');
            if (blockUK) blockUK.classList.remove('is-hidden');

            const monthEl = months[i];
            if (!monthEl) return;

            // Recorre los días marcados en ese mes y llena cada lista
            monthEl.querySelectorAll('.calendar-widget__day.is-holiday').forEach(dayEl => {
                const mx = getDataArray(dayEl, 'mx');
                const us = getDataArray(dayEl, 'us');
                const uk = getDataArray(dayEl, 'uk');

                if (listMX && mx.length) mx.forEach(it => addItem(listMX, it, 'mx'));
                if (listUS && us.length) us.forEach(it => addItem(listUS, it, 'us'));
                if (listUK && uk.length) uk.forEach(it => addItem(listUK, it, 'uk'));
            });

            // Oculta bloques vacíos (si no hay feriados de ese país en el mes)
            if (blockMX && (!listMX || !listMX.children.length)) blockMX.classList.add('is-hidden');
            if (blockUS && (!listUS || !listUS.children.length)) blockUS.classList.add('is-hidden');
            if (blockUK && (!listUK || !listUK.children.length)) blockUK.classList.add('is-hidden');
        }

        // Cambia el mes visible y actualiza header + sidebar
        function setMonth(i) {
            idx = Math.max(0, Math.min(11, i));
            months.forEach((m, k) => m.setAttribute('aria-hidden', k === idx ? 'false' : 'true'));
            lbl.textContent = `${monthNames[idx]} ${year}`;
            fillSidebar(idx);
            setNavState();

            setupListHoverHandlers();
            clearCalendarHighlights();
        }

        function setupDayHoverHandlers() {
            const days = root.querySelectorAll('.calendar-widget__day.is-holiday');

            // Accesible con teclado
            days.forEach(day => {
                if (!day.hasAttribute('tabindex')) day.setAttribute('tabindex', '0');
            });

            function highlightByDate(dateStr) {
                if (!dateStr) return;
                root.querySelectorAll(`.calendar-widget__sidebar-item[data-date="${dateStr}"]`)
                .forEach(li => li.classList.add('is-active'));
            }

            function clearHighlights() {
                root.querySelectorAll('.calendar-widget__sidebar-item.is-active')
                .forEach(li => li.classList.remove('is-active'));
            }

            days.forEach(day => {
                const dateStr = day.getAttribute('data-date');
                if (!dateStr) return;

                // Hover con mouse
                day.addEventListener('mouseenter', () => {
                clearHighlights();
                highlightByDate(dateStr);
                });
                day.addEventListener('mouseleave', () => {
                clearHighlights();
                });

                // Teclado / accesibilidad
                day.addEventListener('focus', () => {
                clearHighlights();
                highlightByDate(dateStr);
                });
                day.addEventListener('blur', () => {
                clearHighlights();
                });
            });
        }
        function setupListHoverHandlers() {
            // Delegación sobre la columna lateral (se reconstruye cada setMonth)
            const sidebar = root.querySelector('.calendar-widget__sidebar');
            if (!sidebar) return;

            // Por accesibilidad: que los <li> puedan enfocarse
            sidebar.querySelectorAll('.calendar-widget__sidebar-item').forEach(li => {
                if (!li.hasAttribute('tabindex')) li.setAttribute('tabindex', '0');
            });

            function handleEnter(el) {
                const dateStr = el.getAttribute('data-date');
                if (!dateStr) return;
                // si el día pertenece a otro mes, cámbialo
                ensureMonthVisibleForDate(dateStr);
                // resaltar en el calendario
                highlightCalendarDayByDate(dateStr);
            }

            function handleLeave() {
                clearCalendarHighlights();
            }

            // Quitamos listeners anteriores para evitar duplicados en cada setMonth
            // (estrategia simple: clonar nodo y reemplazar)
            ['#gbm-list-mx', '#gbm-list-us', '#gbm-list-uk'].forEach(sel => {
                const ul = root.querySelector(sel);
                if (!ul) return;
                const clone = ul.cloneNode(true);
                ul.parentNode.replaceChild(clone, ul);
            });

            // Vuelve a seleccionar ya clonados
            const lists = [
                root.querySelector('#gbm-list-mx'),
                root.querySelector('#gbm-list-us'),
                root.querySelector('#gbm-list-uk')
            ].filter(Boolean);

            lists.forEach(list => {
                list.querySelectorAll('.calendar-widget__sidebar-item').forEach(li => {
                li.addEventListener('mouseenter', () => handleEnter(li));
                li.addEventListener('mouseleave', handleLeave);
                li.addEventListener('focus',    () => handleEnter(li));
                li.addEventListener('blur',     handleLeave);
                });
            });
        }

        if (prev) prev.addEventListener('click', e => { e.preventDefault(); if (idx > 0)  setMonth(idx - 1); });
        if (next) next.addEventListener('click', e => { e.preventDefault(); if (idx < 11) setMonth(idx + 1); });

        // Mostrar el mes actual
        setMonth(idx);

        // Vincular hover/focus
        setupDayHoverHandlers();
    }

    document.addEventListener('DOMContentLoaded', function () {
        const widget = document.getElementById('calendar_widget');
        if (widget) {
        initCalendar(widget);
        return;
        }
    });

})();